/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ItineratorError,
  ItineratorGetLocationsParams,
  ItineratorLocation,
  ItineratorLocationList,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Locations<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Location
   * @name GetLocations
   * @summary List all locations
   * @request GET:/locations
   * @secure
   */
  getLocations = (query?: ItineratorGetLocationsParams, params: RequestParams = {}) =>
    this.request<ItineratorLocationList, ItineratorError>({
      path: `/locations`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Location
   * @name GetLocationBySlug
   * @summary Find a location by slug
   * @request GET:/locations/{slug}
   * @secure
   */
  getLocationBySlug = (slug: string | number, params: RequestParams = {}) =>
    this.request<ItineratorLocation, ItineratorError>({
      path: `/locations/${slug}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
